export * from './DocXIcon';
export * from './DocXIcon16Light';
export * from './DocXIcon16Regular';
export * from './DocXIcon16Solid';
export * from './DocXIcon20Light';
export * from './DocXIcon20Regular';
export * from './DocXIcon20Solid';
export * from './DocXIcon24Regular';
export * from './DocXIcon24Solid';
export * from './DocXIcon32Regular';
export * from './DocXIcon64Regular';
